<div
  echarts
  [options]="options"
  [merge]="merge"
  [loading]="loading"
  [autoResize]="true"
  [initOpts]="initOpts"
  [theme]="theme"
  [loadingOpts]="loadingOpts"
  (chartInit)="onChartInit($event)"
  (chartClick)="onChartClick($event)"
  (chartDblClick)="onChartDblClick($event)"
  (chartMouseDown)="onChartMouseDown($event)"
  (chartMouseMove)="onChartMouseMove($event)"
  (chartMouseUp)="onChartMouseUp($event)"
  (chartMouseOver)="onChartMouseOver($event)"
  (chartMouseOut)="onChartMouseOut($event)"
  (chartRendered)="onChartRendered()"
  (chartFinished)="onChartFinished()"
  (chartDataZoom)="onDataZoom($event)"
  class="echarts"
></div>
